<template>
  <div class="awards-swiper">
    <swiper :options="swiperOptions" ref="swiper">
      <swiper-slide v-for="(item, index) in awardList" :key="index">
        <div class="award-card">
          <img :src="item.awardLogo" class="logo" />
          <div>
            <span class="title">{{ item.awardTitle }}</span><br/>
            <span class="title" v-if="item.awardSubtitle">{{ item.awardSubtitle }}</span>
            <p class="field" v-if="item.awardField">{{ item.awardField }}</p>
          </div>
        </div>
      </swiper-slide>
      <!-- <div class="swiper-pagination"  slot="pagination"></div> -->
    </swiper>
  </div>
</template>
<script>



export default ({
  data() {
    return {
      awardList: [
        {
          awardTitle: "Member of",
          awardSubtitle: null,
          awardField: "ACS",
          awardLogo: require('@/assets/imgs/pc/Recognised/acsColor.png')
        },
        {
          awardTitle: "Member of",
          awardSubtitle: null,
          awardField: "Stone & Chalk",
          awardLogo: require('@/assets/imgs/pc/Recognised/stoneAndChalkColor.png')
        },
        {
          awardTitle: "The Urban Developer ",
          awardSubtitle: "Awards Finalist",
          awardField: "Best New PropTech",
          awardLogo: require('@/assets/imgs/pc/Recognised/urbanDeveloper.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Design & Development",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechDesign.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Operations & Management",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechOperation.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Efficiency & Optimisation",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechEfficiency.png')
        },
        {
          awardTitle: "Proptech Awards ",
          awardSubtitle: "Finalist",
          awardField: "Design, Build & Develop",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechDevelop.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Proptech for Good",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechGood.png')
        },
      ],
      swiperOptions: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1200: { slidesPerView: 5, slidesPerGroup: 5 },
          992: { slidesPerView: 4, slidesPerGroup: 4 },
          920: { slidesPerView: 3, slidesPerGroup: 3 },
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          360: { slidesPerView: 1, slidesPerGroup: 1 }
        },
        on: {
          init() {
            this.el.querySelectorAll('.swiper-slide-duplicate').forEach(el => el.setAttribute('aria-hidden', 'true'));
          },
          loopFix() {
            this.el.querySelectorAll('.swiper-slide-duplicate').forEach(el => el.setAttribute('aria-hidden', 'true'));
          }
        }
      }
    }
  },
  mounted() {}
});
</script>

<style scoped>
.awards-swiper {
  width: 100%;       
  padding: 0 20px;   
}
.award-card {
  display: flex;
  flex-direction: column;
  gap: 40px;
  text-align: center;
  align-items: center;
  margin-bottom: 60px !important; 
  .logo {
    height: 105px;
    object-fit: contain;
    margin-bottom: 12px;
  }
  .title {
    color: #062440;
    text-align: center;
    font-family: Poppins-Bold;
    font-size: 20px;
    line-height: 25px;
    width: 100%;
  }
  .field {
    color: #062440;
    padding-top: 8px;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; 
    width: 200px;
  }
}
.swiper-pagination {
  margin-top: 30px;
}
</style>
